// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonPlay_container__3eUEg","compact":"ButtonPlay_compact__2SmAw"};